export default {
  name: {
    id: 'rm_metal_niobium_name',
    defaultMessage: 'Niobium',
  },
  smartphoneLabel: {
    id: 'rm_metal_niobium_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_niobium_what_it_does',
    defaultMessage:
      'Niobium compounds such as lithium niobate are used in surface acoustic wave filters and capacitors in smartphones. High-purity niobium oxide can also be used in high-refractive-index glass for camera lenses. Most niobium, however, is used to strengthen steel.',
  },
  extractionText1: {
    id: 'rm_metal_niobium_extraction_p1',
    defaultMessage:
      'Niobium is mined mainly from pyrochlore, its primary ore, and sometimes from columbite-tantalite. Open-pit mines crush, grind and concentrate the ore, then convert it into niobium oxide and ferroniobium. Producers are often integrated, so processing takes place near the mine. Niobium can also be recovered from tin-smelter waste and steel and superalloy scrap.',
  },
  quickFactText: {
    id: 'rm_metal_niobium_quick_fact',
    defaultMessage:
      'Niobium is used in tiny amounts in smartphone filters and camera glass, but around 90% is used to strengthen steel. Supply is highly concentrated, with Brazil producing approximately 92% of the world’s niobium.',
  },
  envSummaryText: {
    id: 'rm_metal_niobium_env_summary',
    defaultMessage:
      'Niobium mining can disturb land, consume water and energy, generate tailings and release mineral-processing waste. Pyrochlore, the main niobium ore, can also contain elevated uranium and thorium, requiring careful management of mining residues.',
  },
  envWaterText: {
    id: 'rm_metal_niobium_env_water_text',
    defaultMessage:
      'Mining and processing can consume water and generate wastewater and tailings. Runoff from mining residues may affect nearby water bodies. Pyrochlore can contain uranium and thorium, which may require additional monitoring and waste controls.',
  },
  envSoilText: {
    id: 'rm_metal_niobium_env_soil_text',
    defaultMessage:
      'Open-pit mining can remove vegetation and topsoil, increasing erosion and generating waste rock and tailings. Residues from pyrochlore processing may contain uranium and thorium and require careful management to avoid soil contamination.',
  },
  envBiodiversityText: {
    id: 'rm_metal_niobium_env_biodiversity_text',
    defaultMessage:
      'Mining can clear vegetation, fragment habitats and alter landscapes. Runoff and tailings can further affect terrestrial and aquatic ecosystems. The sources provide no quantified assessment of niobium-specific biodiversity loss.',
  },
  humanSummaryText: {
    id: 'rm_metal_niobium_human_summary',
    defaultMessage:
      'Niobium has no separately documented human-impact profile. Workers and nearby communities may nevertheless face the general risks associated with mining and mineral processing, including dust, accidents, chemical exposure, land-use changes and pressure on water resources.',
  },
  humanHealthText: {
    id: 'rm_metal_niobium_human_health_text',
    defaultMessage:
      'Pyrochlore can contain elevated uranium and thorium, which may require monitoring and safety controls around mining residues.',
  },
  geoSummaryText: {
    id: 'rm_metal_niobium_geo_summary',
    defaultMessage:
      'Niobium supply is highly concentrated and closely linked to the steel industry. Brazil is by far the leading producer, while Canada is the second-largest producer. A small number of integrated companies control mining and processing, making the market vulnerable to production or policy changes in these countries.',
  },
  geoDugText: {
    id: 'rm_metal_niobium_geo_dug_text',
    defaultMessage:
      'Brazil accounted for approximately 92% of global niobium mine production in 2024, followed by Canada at around 7%. Most industrial output comes from three major operations: Araxá and Catalão in Brazil, and Niobec in Canada. Minor production has also been reported in the Democratic Republic of the Congo, Russia and Rwanda, each contributing less than 1% of global output.',
  },
  geoProcessedText: {
    id: 'rm_metal_niobium_geo_processed_text',
    defaultMessage:
      'Brazil was also the leading country for niobium processing. Niobium-bearing ores and concentrates are often processed near integrated mining operations into ferroniobium, the main commercial niobium product and the most widely traded form, as well as niobium oxide and metal. Other traded forms include ores and concentrates and scrap. Brazil accounted for approximately 89% of global processing-stage production between 2020 and 2024, while Canada accounted for around 11%.',
  },
  geoLeverageText: {
    id: 'rm_metal_niobium_geo_leverage_text',
    defaultMessage:
      'Brazil’s dominant position in niobium mining and processing, combined with the concentration of production among a few integrated companies, gives it significant influence over global supply. The European Union is entirely dependent on imports at the processing stage, with Brazil supplying approximately 85% and Canada 13% of EU demand on average between 2020 and 2024. Export licences in Brazil, Ethiopia, Nigeria and South Africa, as well as export taxes in Burundi and Rwanda, can also affect international trade flows.',
  },
  supplySummaryText: {
    id: 'rm_metal_niobium_supply_summary',
    defaultMessage:
      'While global niobium resources are considered more than adequate for projected demand, supply remains highly concentrated. Global niobium and ferroniobium production is forecast to grow by approximately 2.5% to 3% per year until 2030. However, disruptions in Brazil or Canada could affect the global market.',
  },
  supplyReservesText: {
    id: 'rm_metal_niobium_supply_reserves_text',
    defaultMessage:
      'Global niobium reserves exceed 17 million tonnes, an amount considered more than adequate to meet projected needs. Approximately 16 million tonnes are in Brazil, 1.6 million in Canada and 210,000 tonnes in the United States. Using the rounded 17-million-tonne figure, Brazil represents about 94% of reported reserves, but this is only an approximation. The figures refer to niobium content, not refined metal.',
  },
  supplyDemandText: {
    id: 'rm_metal_niobium_supply_demand_text',
    defaultMessage:
      'About 90% of niobium is used in high-strength steel for construction, vehicles, pipelines and infrastructure. Global demand could rise from 117 kt in 2025 to 190 kt in 2030, a 62% increase. Clean-energy demand is projected to grow from 0.2 kt in 2025 to 0.7 kt in 2050, an increase of approximately 250%. This covers low-emissions power generation, including nuclear, geothermal and concentrated solar power.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_niobium_recycling_summary',
    defaultMessage:
      'There is very little post-consumer functional recycling, with most niobium in steel ending up in slags that are used in road construction or diluted rather than recovered for reuse. Production scrap, tin-smelter waste and alloy scrap can be recovered more easily.',
  },
  recyclingInputText: {
    id: 'rm_metal_niobium_recycling_input_text',
    defaultMessage:
      'In 2020, around 87% of niobium-containing products were collected at the end of their life, but less than 1% of the niobium they contained was recovered. The end-of-life recycling rate was therefore below 1%, and less than 1% of new niobium supply came from recycled end-of-life products. This gap exists because most applications are not recycled for their niobium content, and much of the metal is lost in slag.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_niobium_recycling_outlook_text',
    defaultMessage:
      'Not on its own. Niobium recovery from production scrap and some alloy waste is possible, but post-consumer recycling remains very limited. Niobium in steel is often diluted or lost in slags, while the small amounts used in electronic components are difficult to recover. Primary production will therefore remain necessary.',
  },
  footnote1Text1: {
    id: 'rm_metal_niobium_footnote_1_p1',
    defaultMessage:
      'As Niobium is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
  mine0Region: {
    id: 'rm_metal_niobium_mine0_region',
    defaultMessage: 'Araxá',
  },
  mine1Region: {
    id: 'rm_metal_niobium_mine1_region',
    defaultMessage: 'Ouvidor',
  },
  mine2Region: {
    id: 'rm_metal_niobium_mine2_region',
    defaultMessage: 'Saint-Honoré',
  },
  mine3Region: {
    id: 'rm_metal_niobium_mine3_region',
    defaultMessage: 'Catalão',
  },
  mine4Region: {
    id: 'rm_metal_niobium_mine4_region',
    defaultMessage: 'Lovozero',
  },
} as const
